import ChatImageDetail from '@/screens/ChatImageDetail';

export default function PrivateChatChatIdMediaIndexRoute() {
  return <ChatImageDetail />;
}
